<template>
<el-container style="min-height: 100%;">
    <el-main style="background-color: #fff;">
        <el-form label-position="right" label-width="180px" :model="form" class="pr_20">
            <el-form-item label="登录页系统名称：" prop="system_login_name">
                <el-input v-model="form.system_login_name" clearable placeholder="" maxlength="20" show-word-limit style="width: 500px;"></el-input>
                <span style="margin-left: 10px;" v-if="form.system_login_name">登录地址: {{lgoinUrl}}</span>
            </el-form-item>
            <el-form-item label="订单轮播最低金额：" prop="system_order_carousel_min">
                <el-input-number v-model="form.system_order_carousel_min" :min="0" :max="99999999" :precision="2"></el-input-number>
            </el-form-item>
        </el-form>
    </el-main>
    <el-footer class="foot" style="display: flex;align-items: center;background-color: #fff;">
        <el-button type="primary" style="margin-left: 300px;" @click="setSystem">保存</el-button>
    </el-footer>
</el-container>
</template>
<script>
import {systemset} from "@/request/apis.js"
export default{
    data(){
        return {
            form: {
                system_login_name : '',
                system_order_carousel_min: '',
            },
            lgoinUrl: '',
        }
    },
    mounted() {
        this.getSystem();
        var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
        this.lgoinUrl = location.origin + '/admin/index.html?#/?sid=' + loginInfo.sid;
    },
    methods:{
        async getSystem(){
            var res = await systemset('get');
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.form = {...this.form, ...res.data};
        },
        async setSystem(){
            var res = await systemset('post', this.form);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
        },
    }
}
</script>

<style  scoped>
</style> 